import { IconButton } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import useTranslation from 'Hooks/useTranslation';

const getColumns = ({ handleMenuOpen }) => {
  const { t } = useTranslation();

  return [
    { field: 'name', headerName: t('JobTitle.Name'), flex: 1.5 },
    { field: 'department', headerName: t('JobTitle.Department'), flex: 1 },
    { field: 'numberOfEmployees', headerName: t('JobTitle.TotalEmployees'), flex: 1 },
    { field: 'numberOfCourses', headerName: t('JobTitle.TotalCourses'), flex: 1 },
    { field: 'status', headerName: t('JobTitle.Status'), flex: 0.7 },
    {
      field: 'actions',
      headerName: '',
      width: 60,
      sortable: false,
      renderCell: params => (
        <IconButton size="small" onClick={event => handleMenuOpen(event, params.row)}>
          <MoreVert />
        </IconButton>
      ),
    },
  ];
};

export default getColumns;
